import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MemberStatus } from '../../models';
import {
  StatusIndicatorAppearance,
  StatusIndicatorComponent,
} from '../status-indicator/status-indicator';
import {
  canReinviteCustomerOwner,
  isCustomerInvitationAccepted,
} from '../../utils/organization.utils';

/**
 * Invitation column/chip for managed customer org rows. Centralises the
 * pending / accepted / unknown branching shared by the customers list
 * (grid + table) and customer detail header.
 */
@Component({
  selector: 'app-customer-invitation-indicator',
  imports: [StatusIndicatorComponent],
  templateUrl: './customer-invitation-indicator.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerInvitationIndicatorComponent {
  readonly ownerStatus = input<MemberStatus | undefined>();
  readonly pendingLabel = input.required<string>();
  readonly acceptedLabel = input.required<string>();
  readonly appearance = input<StatusIndicatorAppearance>('inline');
  /** When true, unknown (legacy) rows render a muted placeholder in table cells. */
  readonly showEmptyPlaceholder = input(false);
  readonly emptyPlaceholder = input('—');
  readonly emptyClass = input('data-table-muted');

  protected readonly isPending = computed(() =>
    canReinviteCustomerOwner({ owner_status: this.ownerStatus() })
  );

  protected readonly isAccepted = computed(() =>
    isCustomerInvitationAccepted({ owner_status: this.ownerStatus() })
  );
}
